import { fetchJSON } from "../helpers/fetcher"
import { ENVIRONMENT, getEndpoint } from "./endpoints"

// const tkAccessTokenUrl = getEndpoint(ENVIRONMENT)?.tkAccessToken as string
// const tkAuthorizeUrl = getEndpoint(ENVIRONMENT)?.tkAuthorize as string
const tiktokLogoutUrl = getEndpoint(ENVIRONMENT)?.tiktokLogout as string

export class TiktokAuthService {
  // private static serviceId = process.env.REACT_APP_TIKTOK_SERVICE_ID;
  // private static newAuthUrl = "https://services.tiktokshop.com/open/authorize";
  // private static fullAuthUrl = `${this.newAuthUrl}?service_id=${this.serviceId}`;

  // Not being used. Maybe be this can be removed later
  // static authorize = async () => {
  //   // window.location.href = this.fullAuthUrl;
  //   return await fetch(tkAuthorizeUrl);
  // }

  // Not being used. Maybe be this can be removed later
  // static getAccessToken = async (code: string) => {
  //   const headers = {
  //     "auth_code": code
  //   }
  //   return await fetchJSON(tkAccessTokenUrl, "GET", undefined, headers)
  // }

  static logout = async () => {
    return await fetchJSON(tiktokLogoutUrl, "POST", {})
  }
}
